/* tslint:disable */
 
import { CollectionValueModel } from './collection-value-model';
import { NullableReferenceProperty } from './nullable-reference-property';
import { ReferenceProperty } from './reference-property';
export class UserStateDataEntryValue {
  dateFormat?: null | CollectionValueModel;
  dateTimeFormat?: null | CollectionValueModel;
  firstLogin?: boolean;
  fontSize?: number;
  language?: ReferenceProperty;
  layoutMode?: string;
  menuMode?: string;
  theme?: null | NullableReferenceProperty;
  timeFormat?: null | CollectionValueModel;
  timeZone?: null | NullableReferenceProperty;
  user?: ReferenceProperty;
}
